import React, { useState } from "react";
import styles from "../styles.module.css";

const CreateAssessmentForm = () => {
  const [assessmentName, setAssessmentName] = useState("");
  const [behavioralQuestionsFile, setBehavioralQuestionsFile] = useState(null);
  const [skillQuestionsFile, setSkillQuestionsFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file && file.type === "text/csv") {
      if (type === "behavioral") {
        setBehavioralQuestionsFile(file);
      } else if (type === "skill") {
        setSkillQuestionsFile(file);
      }
      setError("");
    } else {
      setError("Please upload a valid CSV file.");
    }
  };

  const handleSubmit = async () => {
    if (!assessmentName || !behavioralQuestionsFile || !skillQuestionsFile) {
      setError("All fields are required.");
      return;
    }

    const formData = new FormData();
    formData.append("assessmentName", assessmentName);
    formData.append("behavioralQuestions", behavioralQuestionsFile);
    formData.append("skillQuestions", skillQuestionsFile);

    try {
      // Replace this URL with the actual API endpoint
      const response = await fetch("https://api.example.com/upload-assessment", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setMessage("Assessment created successfully!");
        setAssessmentName("");
        setBehavioralQuestionsFile(null);
        setSkillQuestionsFile(null);
      } else {
        setError("Failed to create assessment. Please try again.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className={styles.formContainer}>
      <h2>Create Assessment</h2>
      <form className={styles.assignForm}>
        {/* Assessment Name */}
        <div className={styles.formRow}>
          <label>Assessment Name:</label>
          <input
            type="text"
            value={assessmentName}
            onChange={(e) => setAssessmentName(e.target.value)}
            placeholder="Enter assessment name"
            className={styles.textInput}
          />
        </div>

        {/* Behavioral Questions File */}
        <div className={styles.formRow}>
          <label>Behavioral Questions (CSV):</label>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => handleFileChange(e, "behavioral")}
            className={styles.fileInput}
          />
          {behavioralQuestionsFile && (
            <p className={styles.fileName}>
              Selected file: {behavioralQuestionsFile.name}
            </p>
          )}
        </div>

        {/* Skill Questions File */}
        <div className={styles.formRow}>
          <label>Skill Questions (CSV):</label>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => handleFileChange(e, "skill")}
            className={styles.fileInput}
          />
          {skillQuestionsFile && (
            <p className={styles.fileName}>
              Selected file: {skillQuestionsFile.name}
            </p>
          )}
        </div>

        {/* Submit Button */}
        <div className={styles.buttonContainer}>
          <button
            type="button"
            onClick={handleSubmit}
            className={styles.submitButton}
          >
            Upload and Create Assessment
          </button>
        </div>

        {/* Messages */}
        {message && <p className={styles.successMessage}>{message}</p>}
        {error && <p className={styles.errorMessage}>{error}</p>}
      </form>
    </div>
  );
};

export default CreateAssessmentForm;
